module.exports = __webpack_public_path__ + "img/sdg7_jp.ad82e838.png";